import React from 'react'
import { Link, NavLink } from 'react-router-dom'

const NavbarComponent = () => {
    return (
        <header className="ocn-header">
            <div className="ocn-wrap">
                <Link to="/" className="ocn-brand" aria-label="OpenCodeNet home">
                    <span className="ocn-brand-mark" aria-hidden="true">{'</>'}</span>
                    <span className="word">OpenCodeNet</span>
                </Link>
                <nav className="ocn-nav" aria-label="Main">
                    <NavLink to="/" end>Home</NavLink>
                    <NavLink to="/label">Label</NavLink>
                    <NavLink to="/datasets">Datasets</NavLink>
                    <NavLink to="/projects">Projects</NavLink>
                </nav>
            </div>
        </header>
    )
}

export default NavbarComponent
